/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { injectIntl } from 'react-intl';

const propTypes = {
  /** the base url of the walkme server content */
  walkmeURL: PropTypes.string,
  isLoggedIn: PropTypes.bool,
};

const defaultProps = {
  walkmeURL: null,
  isLoggedIn: false,
};

const WalkmeEnablement = ({ isLoggedIn, walkmeURL, intl: { locale } }) => {
  let [language] = locale.split('-');
  // Special fix because the languages are different in walkme
  switch (locale) {
    case 'nb':
      language = 'no';
      break;
    case 'pt-BR':
      language = 'pt-BR';
      break;
    case 'zh':
    case 'zh-CN':
    case 'zh-SG':
      language = 'zh-Hans';
      break;
    case 'zh-TW':
    case 'zh-HK':
    case 'zh-MO':
      language = 'zh-Hant';
      break;
    default:
  }
  if (!isLoggedIn) {
    return null;
  }
  return walkmeURL ? (
    <Helmet>
      <script>{`window._walkmeConfig = {smartLoad:true};
                window.walkme_get_language = function () {
                  return '${language === 'en' ? '' : language}';
                }
              `}</script>
      <script type="text/javascript" src={walkmeURL} />
    </Helmet>
  ) : null;
};

WalkmeEnablement.propTypes = propTypes;
WalkmeEnablement.defaultProps = defaultProps;

export default injectIntl(WalkmeEnablement);
